import BusinessAccountPage from 'screens/BusinessAccount/BusinessAccount';

export default BusinessAccountPage;
